import React from 'react'
import PropTypes from 'prop-types'

import styles from './LocationPopupContent.module.scss'

const LocationPopupContent = props => {
  const { activeLayers, hideCoords, layers, point } = props

  const rows = layers.map((layer, i) => {
    return (
      <div key={i} className={styles.layerRow}>
        <p>
          {layer.state.replace('_', ' ')} - {layer.category} - {layer.name}
        </p>
      </div>
    )
  })

  return (
    <div className={styles.popupContent}>
      <p className={styles.attributeRow}>
        <span className={styles.highlight}>Location: </span>
        {hideCoords ? '--' : point[1].toFixed(4)}, {hideCoords ? '--' : point[0].toFixed(4)}
      </p>
      {activeLayers.length > 0 ? rows : null}
    </div>
  )
}

LocationPopupContent.propTypes = {
  activeLayers: PropTypes.array,
  county: PropTypes.string,
  hideCoords: PropTypes.bool,
  layers: PropTypes.array,
  metadata: PropTypes.object,
  point: PropTypes.array,
  state: PropTypes.string
}

export default LocationPopupContent
